import typeUtils from '../../helpers/utils/typeUtils.js.es6';
import keyboard from '../../helpers/utils/keyboard.js.es6';

class InlineEditInputField extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            editMode: false
        };

        this._value = props.value;
        this._classNames = ['form-control', 'bl-inline-edit__input'];
        this._onChange = this._onChange.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onBlur = this._onBlur.bind(this);
        this._onKeyUp = this._onKeyUp.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps && typeof newProps === 'object') {
            this._value = newProps.value;
        }
    }

    _onChange(e) {
        if(typeUtils.isFunction(this.props.onChange)){
            this.props.onChange(e);
        }
    }

    _onClick(e) {
        this.setState({
            editMode: true
        });

        if(typeUtils.isFunction(this.props.onClick)){
            this.props.onClick(e);
        }
    }

    _onFocus(e) {
        this.setState({
            editMode: true
        });

        if(typeUtils.isFunction(this.props.onFocus)){
            this.props.onFocus(e);
        }
    }

    _onBlur(e) {
        this.setState({
            editMode: false
        });

        if(typeUtils.isFunction(this.props.onBlur)){
            this.props.onBlur(e);
        }
    }

    _onKeyUp(e) {
        let _k = e.which || e.keyCode,
            _input = e.target;

        switch (_k) {
            case keyboard.ESC:
                e.nativeEvent.stopImmediatePropagation();
                this.setState({ editMode: false });
                _input.blur();
                break;

            case keyboard.TAB:
                this.setState({ editMode: true });
                break;

            default:
                break;
        }

        if(typeUtils.isFunction(this.props.onKeyUp)){
            this.props.onKeyUp({ key: _k }, e);
        }
    }

    _onKeyDown(e) {
        if(typeUtils.isFunction(this.props.onKeyDown)){
            this.props.onKeyDown(e);
        }
    }

    render() {
        return (
            <div className="bl-inline-edit__container form-group">
                <input type="text"
                       readOnly={ !this.state.editMode }
                       value={ this._value }
                       onChange={ this._onChange }
                       onClick={ this._onClick }
                       onFocus={ this._onFocus }
                       onBlur={ this._onBlur }
                       onKeyUp={ this._onKeyUp }
                       onKeyDown={ this._onKeyDown }
                       className={ this._classNames.join(' ') } />
                <i className="bl-inline-edit__icon fa fa-pencil"/>
            </div>
        );
    }
}

BOOKLIST.components.InlineEditInputField = InlineEditInputField;
export default InlineEditInputField;